import gql from "../gql";
import AssignedLearning from "./AssignedLearning";
export default gql `
  fragment AssignedLearnings on AssignedLearningSummaryConnection {
    __typename
    edges {
      __typename
      node {
        ...AssignedLearning
      }
    }
    pageInfo {
      __typename
      startCursor
      endCursor
      hasNextPage
    }
  }
  ${AssignedLearning}
`;
